<template>
  <el-dialog
      :visible.sync="visible"
      title="付款详情"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="120px"

    >
      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="4">
          <MLabel label="付款单据号" :value="dataForm.payNo" size="normal"></MLabel>
        </el-col>
        <el-col :span="4">
          <MLabel label="付款时间" :value="dataForm.payDate" size="normal"></MLabel>
        </el-col>
        <el-col :span="4">
          <MLabel label="付款银行" :value="dataForm.payBank" size="normal"></MLabel>
        </el-col>
        <el-col :span="4">
          <MLabel label="付款账户" :value="dataForm.payAccount" size="normal"></MLabel>
        </el-col>
        <el-col :span="4">
          <MLabel label="收款行" :value="dataForm.receiverBank" size="normal"></MLabel>
        </el-col>

      </el-row>
      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="4">
          <MLabel label="收款人" :value="dataForm.receiverName" size="normal"></MLabel>
        </el-col>
        <el-col :span="4">
          <MLabel label="收款账户" :value="dataForm.receiverAccount" size="normal"></MLabel>
        </el-col>
        <!--        <el-col :span="4">-->
        <!--          <MLabel label="凭证照片" :value="dataForm.remark" size="normal"></MLabel>-->
        <!--        </el-col>-->
        <el-col :span="4">
          <MLabel label="制单人" :value="dataForm.creatorName" size="normal"></MLabel>
        </el-col>
        <el-col :span="4">
          <MLabel label="制单时间" :value="dataForm.createDate" size="normal"></MLabel>
        </el-col>
      </el-row>
      <el-row :gutter="16" style="padding-left: 10px;" v-if="dataForm.remark">
        <el-col :span="24">
          <MLabel label="备注" :value="dataForm.remark" size="normal"></MLabel>
        </el-col>
      </el-row>
      <SweetTable ref="table" v-if="id" url="/erp/pay/money/detail/list" :is-page="false" :height="300" :query-form="{pid:id}"
                  :before-table-binding="beforeTableBinding"
                  :summaries-column="['amount']">
        <el-table-column prop="code" label="发票号" align="center" header-align="center">
        </el-table-column>
        <el-table-column prop="sellerName" label="销售方" min-width="90" align="center"
                         header-align="center"></el-table-column>
        <el-table-column prop="amount" width="120" label="付款金额" align="center" header-align="center">
          <template #default="{row}">
            <span>{{row.amount}}</span>
            <el-tag type="danger" v-if="row.perPayId" size="mini" style="margin-left: 10px;">预付款</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true" align="center" header-align="center">
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import BigNumber from 'bignumber.js'
import MLabel from '@/components/MLabel/index.vue'

export default {
  name: 'MoneyDetailDialog',
  components: { MLabel },
  data () {
    return {
      dataForm: {},
      visible: false,
      id: '',
      productType: ''
    }
  },
  methods: {
    init (id) {
      this.id = id
      this.getInfo()
      this.visible = true
      this.$nextTick(() => {
        this.$refs.table.reload()
      })
    },
    getInfo () {
      if (!this.id) {
        return
      }
      this.$api.get(`/erp/pay/money/${this.id}`).then(res => {
        this.dataForm = {
          ...res
        }
        console.log(this.dataForm)
      })
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
      })
    },
    cancel () {
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
